export default __webpack_public_path__ + "static/media/Fastlink.04488a05.png";